import { render, staticRenderFns } from "./RowActionMenuButton.vue?vue&type=template&id=706fc591&scoped=true"
import script from "./RowActionMenuButton.vue?vue&type=script&lang=js"
export * from "./RowActionMenuButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706fc591",
  null
  
)

export default component.exports